import React from "react";
import MobileOverallSummary from "./MobileOverallSummary";
import MobileSectionSummary from "./MobileSectionSummary";
import MobileQuestionAnalysis from "./MobileQuestionAnalysis";
import "../styles/mobileresultpage.css";



const MobileResultPage = ({
    activeTab,
    score,
    scoreData,
    userRank,
    userPercentile,
    attemptData,

    quesData,
    ansArray,

    subcats,
    attemptedques,
    correctques,

    catName,
}) => {

    const attemptedCount =
    ansArray.filter(x=>x!==undefined).length;

const accuracy =
    attemptedCount===0
        ?0
        :Math.round(score/attemptedCount*100);

   return(

<div className="mr-root">

    <h1 className="mr-title">

        Exam Result

    </h1>

    <MobileOverallSummary

        scoreData={scoreData}

        attemptData={attemptData}

        userRank={userRank}

        userPercentile={userPercentile}

        accuracy={accuracy}

    />

    <MobileSectionSummary

    quesData={quesData}

    subcats={subcats}

    attemptedques={attemptedques}

    correctques={correctques}

/>

<MobileQuestionAnalysis
    quesData={quesData}
    ansArray={ansArray}
    subcats={subcats}
    
/>

</div>

);

};

export default MobileResultPage;